/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyConsumableStock from './pharmacy-consumable-stock';
import PharmacyConsumableStockDetail from './pharmacy-consumable-stock-detail';
import PharmacyConsumableStockUpdate from './pharmacy-consumable-stock-update';
import PharmacyConsumableStockDeleteDialog from './pharmacy-consumable-stock-delete-dialog';

const PharmacyConsumableStockRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyConsumableStock />} />
    <Route path="new" element={<PharmacyConsumableStockUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyConsumableStockDetail />} />
      <Route path="edit" element={<PharmacyConsumableStockUpdate />} />
      <Route path="delete" element={<PharmacyConsumableStockDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyConsumableStockRoutes;
